import styled, { css } from 'styled-components'
import {
  typography,
  TypographyProps,
  color as styledSystemColor,
} from 'styled-system'
import { between } from 'polished'
import { UIColorTheme, CommonProps, COMMON } from 'global'

interface ITextProps
  extends ITextStyleProps,
    TypographyProps,
    CommonProps,
    UIColorTheme {}

export interface ITextStyleProps {
  large?: boolean
  small?: boolean
  caps?: boolean
  selectable?: boolean
}

export const Text = styled.p<ITextProps>`
  ${({ caps, large, small, theme, color, uiColorTheme, selectable }) => css`
  ${COMMON}
  ${typography}
  ${styledSystemColor}
  color: ${color || (uiColorTheme === 'light' ? '#fff' : '#000')};
  user-select: ${selectable ? 'auto' : 'none'}
  line-height: 1.5;
  text-transform: ${caps && 'uppercase'};

  ${small &&
    css`
      font-size: ${between(
        '12px',
        '14px',
        theme.maxWidths.small,
        theme.maxWidths.xLarge
      )};
      line-height: ${between(
        '18px',
        '22px',
        theme.maxWidths.small,
        theme.maxWidths.xLarge
      )};
      font-weight: 500;
      letter-spacing: 0;

      b {
        font-weight: 900;
      }
    `}

  ${large &&
    css`
      font-size: ${between(
        '24px',
        '26px',
        theme.maxWidths.small,
        theme.maxWidths.xLarge
      )};
      line-height: ${between(
        '28px',
        '34px',
        theme.maxWidths.small,
        theme.maxWidths.xLarge
      )};
      font-weight: 300;
      letter-spacing: 0;

      b {
        font-weight: 900;
      }
    `}
`}
`
